<div class="property-history">
  <!-- Barra de filtros -->
  <div class="history-toolbar">
    <div class="history-search">
      <i class="ri-search-line"></i>
      <input type="text" class="form-control" [formControl]="searchControl"
        [placeholder]="'t-property-history-search' | translate" />
    </div>

    <ng-select class="history-select" [items]="periodOptions" bindValue="value" [clearable]="false"
      [searchable]="false" [(ngModel)]="period" (change)="onPeriodChange()">
      <ng-template ng-label-tmp let-item="item">{{ item.label | translate }}</ng-template>
      <ng-template ng-option-tmp let-item="item">{{ item.label | translate }}</ng-template>
    </ng-select>

    <ng-select class="history-select" [items]="typeOptions" bindValue="value" [clearable]="true"
      [searchable]="false" [(ngModel)]="typeFilter" (change)="reload()"
      [placeholder]="'t-property-history-type-all' | translate">
      <ng-template ng-label-tmp let-item="item">{{ item.label | translate }}</ng-template>
      <ng-template ng-option-tmp let-item="item">{{ item.label | translate }}</ng-template>
    </ng-select>

    <button type="button" class="btn btn-dark btn-sm history-filters-btn" (click)="showFilters = !showFilters">
      <i class="ri-equalizer-line me-1"></i>{{ 't-property-history-filters' | translate }}
      <span class="badge bg-light text-dark ms-1" *ngIf="activeFiltersCount">{{ activeFiltersCount }}</span>
    </button>
  </div>

  <!-- Filtros avançados -->
  <div class="history-advanced" *ngIf="showFilters || period === 'custom'">
    <div class="row g-2 align-items-end">
      <ng-container *ngIf="period === 'custom'">
        <div class="col-6 col-md-3">
          <label class="form-label fs-12 text-muted mb-1">{{ 't-property-history-date-from' | translate }}</label>
          <input type="date" class="form-control form-control-sm" [(ngModel)]="dateFrom" (change)="reload()" />
        </div>
        <div class="col-6 col-md-3">
          <label class="form-label fs-12 text-muted mb-1">{{ 't-property-history-date-to' | translate }}</label>
          <input type="date" class="form-control form-control-sm" [(ngModel)]="dateTo" (change)="reload()" />
        </div>
      </ng-container>

      <ng-container *ngIf="showFilters">
        <div class="col-12 col-md-5">
          <label class="form-label fs-12 text-muted mb-1">{{ 't-property-history-user' | translate }}</label>
          <ng-select [items]="actors" bindLabel="name" bindValue="id" [(ngModel)]="userId" (change)="reload()"
            [placeholder]="'t-property-history-all-users' | translate"></ng-select>
        </div>
        <div class="col-12 col-md-5">
          <label class="form-label fs-12 text-muted mb-1">{{ 't-property-history-result' | translate }}</label>
          <ng-select [items]="statusOptions" bindValue="value" [searchable]="false" [(ngModel)]="status"
            (change)="reload()" [placeholder]="'t-property-history-all-results' | translate">
            <ng-template ng-label-tmp let-item="item">{{ item.label | translate }}</ng-template>
            <ng-template ng-option-tmp let-item="item">{{ item.label | translate }}</ng-template>
          </ng-select>
        </div>
        <div class="col-12 col-md-2 text-md-end">
          <button type="button" class="btn btn-link btn-sm p-0" (click)="clearFilters()">
            {{ 't-property-history-clear' | translate }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Linha temporal -->
  <div class="history-body">
    <div class="history-state" *ngIf="loading && !days.length">
      <div class="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
      {{ 't-property-history-loading' | translate }}
    </div>

    <div class="history-state text-danger" *ngIf="loadError">
      <i class="ri-error-warning-line me-1"></i>{{ 't-property-history-error' | translate }}
      <button type="button" class="btn btn-link btn-sm" (click)="load()">{{ 't-property-history-retry' | translate }}</button>
    </div>

    <div class="history-state" *ngIf="!loading && !loadError && !days.length">
      <i class="ri-history-line me-1"></i>{{ 't-property-history-empty' | translate }}
    </div>

    <div class="history-day" *ngFor="let day of days; trackBy: trackByKey" [class.is-loading]="loading">
      <span class="history-day-label">{{ day.label }}</span>

      <div class="history-item" *ngFor="let item of day.items; trackBy: trackById">
        <div class="history-dot" [ngClass]="'tone-' + item.category" [class.tone-failed]="!item.ok">
          <i [class]="item.ok ? item.icon : 'ri-close-line'"></i>
        </div>

        <div class="history-card" [class.is-failed]="!item.ok">
          <div class="d-flex justify-content-between align-items-start gap-2">
            <div class="min-w-0">
              <div class="history-category" [ngClass]="'text-tone-' + item.category">
                {{ 't-property-history-cat-' + item.category | translate }}
                <span class="badge badge-soft-danger ms-1" *ngIf="!item.ok">
                  {{ 't-property-history-result-error' | translate }}
                </span>
              </div>
              <div class="history-title">{{ item.title | translate: item.titleParams }}</div>
            </div>
            <span class="history-time" [ngbTooltip]="item.createdAt | date: 'dd/MM/yyyy HH:mm:ss'" container="body">
              {{ item.time }}
            </span>
          </div>

          <!-- Uma única alteração simples: destaque antes → depois -->
          <div class="history-highlight" *ngIf="item.highlight as change">
            <span class="old" *ngIf="change.before !== '—'">{{ change.before }}</span>
            <span class="old-empty" *ngIf="change.before === '—'">—</span>
            <i class="ri-arrow-right-line"></i>
            <span class="new">{{ change.after }}</span>
          </div>

          <!-- Várias alterações -->
          <div class="history-changes" *ngIf="!item.highlight && item.changes.length">
            <ng-container *ngFor="let change of item.changes; let i = index">
              <div class="history-change" *ngIf="item.expanded || i < visibleChanges">
                <div class="history-change-label">
                  <span class="change-type" [ngClass]="'type-' + change.changeType">
                    {{ 't-property-history-change-' + change.changeType | translate }}
                  </span>
                  {{ change.label | translate }}<span *ngIf="change.suffix"> · {{ change.suffix }}</span>
                </div>
                <div class="history-change-values" [class.is-long]="change.longText"
                  *ngIf="change.before || change.after">
                  <span class="old">{{ change.before }}</span>
                  <i class="ri-arrow-right-line"></i>
                  <span class="new">{{ change.after }}</span>
                </div>
                <div class="history-change-details" *ngIf="change.details.length">
                  <div *ngFor="let detail of change.details">
                    <span class="text-muted">{{ detail.label | translate }}:</span>
                    <span class="old">{{ detail.before }}</span>
                    <i class="ri-arrow-right-line"></i>
                    <span class="new">{{ detail.after }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
            <button type="button" class="btn btn-link btn-sm p-0" *ngIf="item.changes.length > visibleChanges"
              (click)="toggle(item)">
              {{ (item.expanded ? 't-property-history-show-less' : 't-property-history-show-all') | translate: { count: item.changes.length } }}
            </button>
          </div>

          <!-- Ficheiro envolvido -->
          <div class="history-file" *ngIf="item.file as file">
            <i [class]="file.kind === 'image' ? 'ri-image-line' : 'ri-file-text-line'"></i>
            <div class="min-w-0">
              <div class="text-truncate fw-medium">{{ file.name }}</div>
              <div class="fs-11 text-muted">
                {{ 't-property-history-file-' + file.kind | translate }}
                <span *ngIf="file.typeName"> · {{ file.typeName }}</span>
                <span *ngIf="file.size"> · {{ file.size }}</span>
              </div>
              <div class="fs-11 text-muted" *ngIf="item.previousFile as previous">
                {{ 't-property-history-file-replaced' | translate }}: {{ previous.name }}
              </div>
            </div>
          </div>

          <!-- Reordenação -->
          <div class="history-changes" *ngIf="item.moves.length">
            <div class="history-change" *ngFor="let move of item.moves">
              <span class="text-truncate">{{ move.name || ('t-property-history-file-image' | translate) }}</span>
              <span class="old ms-2">#{{ move.from }}</span>
              <i class="ri-arrow-right-line"></i>
              <span class="new">#{{ move.to }}</span>
            </div>
          </div>

          <div class="history-notes" *ngIf="item.notes.length">
            <div *ngFor="let note of item.notes">
              {{ note.key | translate: note.params }}<span *ngIf="note.text">: {{ note.text }}</span>
            </div>
          </div>

          <div class="history-footer">
            <div class="d-flex align-items-center gap-2 min-w-0">
              <span class="history-avatar">{{ item.actorInitials }}</span>
              <div class="min-w-0">
                <div class="history-actor text-truncate">{{ item.actorName }}</div>
                <div class="history-actor-meta text-truncate" *ngIf="item.actorRole || item.actorEmail">
                  {{ item.actorRole || item.actorEmail }}
                </div>
                <div class="history-actor-meta text-warning text-truncate" *ngIf="item.impersonatorName">
                  <i class="ri-eye-line me-1"></i>{{ 't-activity-log-impersonated-by' | translate: { value: item.impersonatorName } }}
                </div>
              </div>
            </div>
            <span class="history-source" *ngIf="item.source">
              {{ 't-property-history-origin' | translate }}: {{ 't-property-history-source-' + item.source | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Rodapé -->
  <div class="history-pagination" *ngIf="total > 0">
    <div class="fs-12 text-muted">
      {{ 't-property-history-showing' | translate: { count: shownCount, total: total } }}
    </div>
    <ngb-pagination [collectionSize]="total" [pageSize]="pageSize" [(page)]="page" [maxSize]="4" [rotate]="true"
      [ellipses]="true" [boundaryLinks]="false" size="sm" (pageChange)="load()">
      <ng-template ngbPaginationPrevious>{{ 't-property-history-previous' | translate }}</ng-template>
      <ng-template ngbPaginationNext>{{ 't-property-history-next' | translate }}</ng-template>
    </ngb-pagination>
    <button type="button" class="btn btn-light btn-sm" (click)="exportCsv()" [disabled]="exporting">
      <span class="spinner-border spinner-border-sm me-1" *ngIf="exporting"></span>
      {{ 't-property-history-export' | translate }}
    </button>
  </div>
</div>
